/*
 * Current week per date
 */
export const FETCH_CURRENT_WEEK_USAGE_PER_DATE_BEGIN =
  "FETCH_CURRENT_WEEK_USAGE_PER_DATE_BEGIN";
export const FETCH_CURRENT_WEEK_USAGE_PER_DATE_FAILURE =
  "FETCH_CURRENT_WEEK_USAGE_PER_DATE_FAILURE";
export const FETCH_CURRENT_WEEK_USAGE_PER_DATE_SUCCESS =
  "FETCH_CURRENT_WEEK_USAGE_PER_DATE_SUCCESS";

/*
 * Current week volume
 */
export const FETCH_CURRENT_WEEK_USAGE_VOLUME_BEGIN =
  "FETCH_CURRENT_WEEK_USAGE_VOLUME_BEGIN";
export const FETCH_CURRENT_WEEK_USAGE_VOLUME_FAILURE =
  "FETCH_CURRENT_WEEK_USAGE_VOLUME_FAILURE";
export const FETCH_CURRENT_WEEK_USAGE_VOLUME_SUCCESS =
  "FETCH_CURRENT_WEEK_USAGE_VOLUME_SUCCESS";

/*
 * Current month per date
 */
export const FETCH_CURRENT_MONTH_USAGE_PER_DATE_BEGIN =
  "FETCH_CURRENT_MONTH_USAGE_BEGIN";
export const FETCH_CURRENT_MONTH_USAGE_PER_DATE_FAILURE =
  "FETCH_CURRENT_MONTH_USAGE_FAILURE";
export const FETCH_CURRENT_MONTH_USAGE_PER_DATE_SUCCESS =
  "FETCH_CURRENT_MONTH_USAGE_SUCCESS";

/*
 * Current month volume
 */
export const FETCH_CURRENT_MONTH_USAGE_VOLUME_BEGIN =
  "FETCH_CURRENT_MONTH_USAGE_VOLUME_BEGIN";
export const FETCH_CURRENT_MONTH_USAGE_VOLUME_FAILURE =
  "FETCH_CURRENT_MONTH_USAGE_VOLUME_FAILURE";
export const FETCH_CURRENT_MONTH_USAGE_VOLUME_SUCCESS =
  "FETCH_CURRENT_MONTH_USAGE_VOLUME_SUCCESS";

/*
 * Current year per date
 */
export const FETCH_CURRENT_YEAR_USAGE_PER_DATE_BEGIN =
  "FETCH_CURRENT_YEAR_USAGE_PER_DATE_BEGIN";
export const FETCH_CURRENT_YEAR_USAGE_PER_DATE_FAILURE =
  "FETCH_CURRENT_YEAR_USAGE_PER_DATE_FAILURE";
export const FETCH_CURRENT_YEAR_USAGE_PER_DATE_SUCCESS =
  "FETCH_CURRENT_YEAR_USAGE_PER_DATE_SUCCESS";

/*
 * Current year volume
 */
export const FETCH_CURRENT_YEAR_USAGE_VOLUME_BEGIN =
  "FETCH_CURRENT_YEAR_USAGE_VOLUME_BEGIN";
export const FETCH_CURRENT_YEAR_USAGE_VOLUME_FAILURE =
  "FETCH_CURRENT_YEAR_USAGE_VOLUME_FAILURE";
export const FETCH_CURRENT_YEAR_USAGE_VOLUME_SUCCESS =
  "FETCH_CURRENT_YEAR_USAGE_VOLUME_SUCCESS";



// WEBPACK FOOTER //
// ./src/constants/usageActionsTypes.js